import PropTypes from "prop-types";
import React from "react";
import styled, { css } from "styled-components";
// import { Link } from "react-router-dom";

import { config } from "_config";
import breakpoints from "_constants/breakpoints";
import { UPSELL_PRODUCT_CODES } from "_constants";

const UserProfileContainer = styled.div`
  display: flex;
  width: 500px;
  min-height: 270px;
  padding: 32px;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 48px;
  background-color: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);
  ${({ theme: { mobile } }) =>
    mobile
      ? css`
          width: 100%;
          align-items: center;
          padding: 16px 14px 21px;
          margin-bottom: 0;
        `
      : css`
          @media (max-width: 1350px) {
            order: 3;
            width: 90%;
          }
        `}
`;
const Line = styled.div`
  width: 100%;
  border-top: 1px solid #ecedf1;
  margin-top: 12px;
  margin-bottom: 19px;
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      flex-direction: column;

      @media (max-width: ${breakpoints.mobileM}) {
        gap: 24px;
      }
    `}

  ${({ theme: { mobile } }) =>
    !mobile &&
    css`
      @media (max-width: 760px) {
        gap: 24px;
      }
    `}
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: ${({ width, theme: { mobile } }) => (!mobile && width) || "100%"};

  @media (max-width: ${breakpoints.mobileM}) {
    gap: 12px;
  }
`;
const Title = styled.div`
  font-family: "Montserrat";
  font-size: 24px;
  line-height: 32px;
  font-weight: bold;
  color: #7b848d;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      text-align: center;
      font-size: 22px;

      @media (max-width: ${breakpoints.mobileM}) {
        font-size: 18px;
      }
    `}
`;
const LinkExternal = styled.a`
  height: 32px;
  margin-left: 14px;
  margin-right: 12px;
  margin-bottom: 5px;
  font-family: "Montserrat";
  font-size: 14px;
  line-height: 24px;
  color: #03589c;
  text-decoration: none;
  &:hover {
    color: #03589c;
    text-decoration: none;
  }

  @media (max-width: ${breakpoints.mobileM}) {
    margin: 0;
    font-size: 14px;
    height: auto;
  }
`;
// const LinkInternal = styled(Link)`
//   height: 32px;
//   margin-left: 14px;
//   margin-right: 12px;
//   margin-bottom: 5px;
//   font-family: "Montserrat";
//   font-size: 14px;
//   line-height: 24px;
//   color: #03589c;
//   text-decoration: none;
//   &:hover {
//     color: #03589c;
//     text-decoration: none;
//   }

//   @media (max-width: ${breakpoints.mobileM}) {
//     margin: 0;
//     font-size: 14px;
//     height: auto;
//   }

//   ${({ theme: { mobile } }) =>
//     !mobile &&
//     css`
//       @media (max-width: 760px) {
//         line-height: 16px;
//         margin: 0 0 12px 0;
//       }
//     `}
// `;

const LinkButton = styled.div`
  height: 32px;
  margin-left: 14px;
  margin-right: 12px;
  margin-bottom: 5px;
  font-family: "Montserrat";
  font-size: 14px;
  line-height: 24px;
  color: #03589c;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #03589c;
    text-decoration: none;
  }

  @media (max-width: ${breakpoints.mobileM}) {
    margin: 0;
    font-size: 14px;
    height: auto;
  }

  ${({ theme: { mobile } }) =>
    !mobile &&
    css`
      @media (max-width: 760px) {
        line-height: 16px;
        margin: 0 0 12px 0;
      }
    `}
`;

const OrangArrow = styled.span`
  color: #f37217;
`;

function RightArrow() {
  return <OrangArrow>→</OrangArrow>;
}

export default function AdditionalServices({ handleSelectUpsell }) {
  return (
    <UserProfileContainer>
      <Col>
        <Title>Additional Services</Title>
        <Line />
        <Row>
          <Col width="60%">
            <LinkExternal href={`${config.trademarkUiUrl}/trademark-registration`}>
              Trademark registration <RightArrow />
            </LinkExternal>

            {/* <LinkExternal href={`${config.trademarkUiUrl}/trademark-registration`}>
              Copyright registration <RightArrow />
            </LinkExternal> */}

            <LinkExternal href={`${config.trademarkUiUrl}/comprehensive-trademark-search`}>
              Comprehensive Search Report <RightArrow />
            </LinkExternal>

            <LinkButton variant="link" onClick={() => handleSelectUpsell(UPSELL_PRODUCT_CODES.trademarkMonitoring)}>
              Trademark Monitoring <RightArrow />
            </LinkButton>

            <LinkButton variant="link" onClick={() => handleSelectUpsell(UPSELL_PRODUCT_CODES.certifiedCopy)}>
              Certified Copy <RightArrow />
            </LinkButton>

            <LinkButton variant="link" onClick={() => handleSelectUpsell(UPSELL_PRODUCT_CODES.revivalFromAbandonment)}>
              Revival From Abandonment <RightArrow />
            </LinkButton>
          </Col>
          <Col width="40%">
            <LinkButton variant="link" onClick={() => handleSelectUpsell(UPSELL_PRODUCT_CODES.extension)}>
              Extensions <RightArrow />
            </LinkButton>

            <LinkExternal href={`${config.trademarkUiUrl}/office-action`}>
              Office Action <RightArrow />
            </LinkExternal>

            <LinkButton variant="link" onClick={() => handleSelectUpsell(UPSELL_PRODUCT_CODES.statementOfUse)}>
              Statement of use <RightArrow />
            </LinkButton>

            <LinkButton variant="link" onClick={() => handleSelectUpsell(UPSELL_PRODUCT_CODES.keepTrademarkAlive)}>
              Filing a Renewal <RightArrow />
            </LinkButton>
          </Col>
        </Row>
      </Col>
    </UserProfileContainer>
  );
}

AdditionalServices.propTypes = {
  handleSelectUpsell: PropTypes.func,
};
